import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { getFormattedDate } from "@/helpers/getFormattedDate"
import { Rate } from "antd"
import { FC } from "react"
import "../../../../pages/website-landing/home/sections/customer-reviews/review-card/ReviewCard.less"
import "./FullReview.less"

const { Text, Title } = WebsiteTypography

type Props = {
  it: ComponentUiReview | undefined
}

const FullReview: FC<Props> = ({ it }) => {
  return (
    <div className={"review-card review-card-full"}>
      <div className={"review-card-content"} style={{ fontSize: 14 }}>
        <div className={"title-wrapper"}>
          <Title color={"white"} level={3} weight={"w700"}>
            {it?.title}
          </Title>
        </div>

        <div className={"review-text-wrapper"}>
          <Text size={"lg"} color={"website-secondary"} lh={"lh-lg"} style={{ textAlign: "left" }}>
            {it?.content}
          </Text>
        </div>
      </div>

      <div className={"review-card-footer"}>
        <div className={"text-block"}>
          <Text size={"md"} color={"orange"} style={{ textTransform: "uppercase" }}>
            {it?.clientName}
          </Text>

          <Text color={"website-secondary"} size={"xs"}>
            {getFormattedDate(it?.feedbackDate)}
          </Text>
        </div>

        <Rate allowHalf disabled defaultValue={it?.rate ? it?.rate : 5} className={"review-rate-box"} />
      </div>
    </div>
  )
}

export default FullReview
